import { gql } from "@apollo/client";

export const FIND_IT_RESOURCE_BY_STRATEGY = gql`
  query FindITResourceByStrategy($uuid: ID!) {
    findITResourceByStrategy(uuid: $uuid) {
      summary
      uuid
    }
  }
`;

export const UPDATE_IT_RESOURCE = gql`
  mutation UpdateITResource($data: UpdateITResourceInput!) {
    content: updateITResource(data: $data) {
      summary
      uuid
    }
  }
`;

export const FIND_ALL_SOFTWARES_BY_IT_RESOURCE = gql`
  query FindAllSoftwaresByItResource($uuid: ID!) {
    findAllSoftwaresByItResource(uuid: $uuid) {
      contactFirstName
      contactLastName
      email
      impactedByLocalizedEvent
      name
      rampUpTime
      redundancyAvailable
      uuid
    }
  }
`;

export const CREATE_SOFTWARE = gql`
  mutation Software($data: CreateSoftwareInput!) {
    createSoftware(data: $data) {
      contactFirstName
      contactLastName
      email
      impactedByLocalizedEvent
      name
      rampUpTime
      redundancyAvailable
      uuid
    }
  }
`;

export const UPDATE_SOFTWARE = gql`
  mutation Software($data: UpdateSoftwareInput!) {
    updateSoftware(data: $data) {
      contactFirstName
      contactLastName
      email
      impactedByLocalizedEvent
      name
      rampUpTime
      redundancyAvailable
      uuid
    }
  }
`;

export const DELETE_SOFTWARE = gql`
  mutation DeleteSoftware($uuid: ID!) {
    deleteSoftware(uuid: $uuid) {
      contactFirstName
      contactLastName
      email
      impactedByLocalizedEvent
      name
      rampUpTime
      redundancyAvailable
      uuid
    }
  }
`;

export const FIND_ALL_HARDWARES_BY_IT_RESOURCE = gql`
  query FindAllHardwaresByItResource($uuid: ID!) {
    findAllHardwaresByItResource(uuid: $uuid) {
      contactFirstName
      contactLastName
      costPerUnit
      countNeeded
      email
      leadTime
      name
      uuid
    }
  }
`;

export const CREATE_HARDWARE = gql`
  mutation Hardware($data: CreateHardwareInput!) {
    createHardware(data: $data) {
      contactFirstName
      contactLastName
      costPerUnit
      countNeeded
      email
      leadTime
      name
      uuid
    }
  }
`;

export const UPDATE_HARDWARE = gql`
  mutation Hardware($data: UpdateHardwareInput!) {
    updateHardware(data: $data) {
      contactFirstName
      contactLastName
      costPerUnit
      countNeeded
      email
      leadTime
      name
      uuid
    }
  }
`;

export const DELETE_HARDWARE = gql`
  mutation DeleteHardware($uuid: ID!) {
    deleteHardware(uuid: $uuid) {
      contactFirstName
      contactLastName
      costPerUnit
      countNeeded
      email
      leadTime
      name
      uuid
    }
  }
`;
